module.exports = __webpack_public_path__ + "img/IMG-20200311-WA0048.c03eac15.jpg";